<template>
	<div>
		<div class="mdc-card pda-24 mgb-24">
			<div class="t-headline7 font-m">{{ $t("1005") }}</div>
			<div class="t-body1 t-color-bodyGrayA mgt-16 font-r">
				{{ summary }}
			</div>
		</div>
		<div class="mdc-card pdt-24 pdl-24 pdb-8 pdr-24 mgb-50">
			<div class="d-flex align-items-center justify-content-between mgb-16" v-if="periodPolicy">
				<div class="t-headline7 font-m flex-grow-1">{{ $t("1006") }}</div>
			</div>
			<div class="pdt-18 pdb-18">
				<div class="align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA">{{ $t("1007") }}</div>
					<div class="t-body1 font-rn">
						{{ displayPeriod(periodPolicy.application) }}
					</div>
				</div>
			</div>
			<div class="pdt-18 pdb-18">
				<div class="align-items-center justify-content-between d-flex">
					<div class="t-body1 font-r t-color-bodyGrayA">{{ $t("1008") }}</div>
					<div class="t-body1 font-rn">
						{{ displayPeriod(periodPolicy.scoreConfirm) }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { utilDateMixin } from "@/mixins/dateUtil";

export default {
	props: ["periodPolicy", "summary"],
	mixins: [utilDateMixin]
};
</script>

<style></style>